import { render, staticRenderFns } from "./UppstartssamtalAddon.vue?vue&type=template&id=75ba1572&"
import script from "./UppstartssamtalAddon.vue?vue&type=script&lang=js&"
export * from "./UppstartssamtalAddon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports